import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from '../components/Common/Button';
import './HomePage.css';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="home-container">
      <div className="home-hero">
        <div className="home-logo">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
        <h1>Asistente Virtual</h1>
        <p className="home-subtitle">Suministros Industriales</p>
        <p className="home-description">
          Tu asistente inteligente para consultas de productos, cotizaciones y soporte
        </p>

        <div className="home-actions">
          {isAuthenticated && user?.is_admin ? (
            <>
              <Button variant="primary" onClick={() => navigate('/admin')}>
                Panel de Administración
              </Button>
              <Button variant="secondary" onClick={() => navigate('/chat')}>
                Ir al Chat
              </Button>
            </>
          ) : isAuthenticated ? (
            <Button variant="primary" onClick={() => navigate('/chat')}>
              Ir al Chat
            </Button>
          ) : (
            <Button variant="primary" onClick={() => navigate('/login')}>
              Iniciar Sesion
            </Button>
          )}
        </div>

        <div className="home-features">
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <h3>Chat en Tiempo Real</h3>
            <p>Respuestas instantaneas a tus consultas</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </svg>
            </div>
            <h3>Cotizaciones Rapidas</h3>
            <p>Genera cotizaciones en segundos</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="1" y="3" width="15" height="13"></rect>
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                <circle cx="5.5" cy="18.5" r="2.5"></circle>
                <circle cx="18.5" cy="18.5" r="2.5"></circle>
              </svg>
            </div>
            <h3>Tracking de Pedidos</h3>
            <p>Rastrea tus pedidos en tiempo real</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
